module.exports = __webpack_public_path__ + "9a5c60d0390a862d0e5254474e919cbc.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/09-Betsolutions-Backgammon.png
// module id = 1731
// module chunks = 2